import React from "react";

import * as S from "./styles";

export const Algas: React.FC = () => {
  return (
    <S.Container>
      <S.Content>
        <S.TextGroup>
          <S.Wrapper>
            <S.Text>
              <p>
                Por mais distópico que pareça esse futuro, as algas marinhas já
                são incorporadas na produção de produtos de moda há alguns anos.
                A Yeezy, marca do rapper Kanye West, lançou em 2019 o Yeezy Foam
                Runners – ou Yeezy Crocs, como ficou conhecido nos{" "}
                <a
                  href="https://www.dazeddigital.com/fashion/article/46002/1/kayne-west-yeezy-crocs-twitter-responses-balenciaga-ugly-shoe-trend"
                  target="_blank"
                  rel="noreferrer"
                >
                  tweets que dividiam opiniões
                </a>{" "}
                sobre o seu visual –, que levava algas na composição do solado,
                substituindo materiais de combustíveis fósseis. Por mais
                duvidosa que seja a forma do calçado, a novidade foi empolgante.
              </p>
            </S.Text>
            <S.Title>Algas</S.Title>
          </S.Wrapper>
        </S.TextGroup>
      </S.Content>
      <S.Photo1Wrapper>
        <S.CreditPhoto1>Yeezy</S.CreditPhoto1>
        <S.Photo1 />
      </S.Photo1Wrapper>
      <S.Content>
        <S.TextGroup>
          <S.TitleWide>
            Fios de
            <br />
            seda de aranha
          </S.TitleWide>
          <S.Wrapper>
            <S.Text>
              <p>
                A Bolt Threads, responsável pelo couro de cogumelo Mylo, não
                parou nele e também é responsável por outro material
                biotecnológico um pouco mais curioso: fios de seda de aranha.
                Por meio da bioengenharia, foi desenvolvida uma proteína
                inspirada nas teias de aranha naturais, replicando sua alta
                resistência à tração, elasticidade, durabilidade e maciez. Após
                um processo de fermentação para produzir a proteína em grandes
                quantidades, ela é isolada, purificada e transformada em fibras
                para ser usada em tecidos.{" "}
              </p>
            </S.Text>
            <S.Text>
              <p>
                A fórmula perfeita custou mais de 4 mil tentativas,{" "}
                <a
                  href="https://www.newyorker.com/tech/annals-of-technology/in-the-future-well-all-wear-spider-silk"
                  target="_blank"
                  rel="noreferrer"
                >
                  segundo o CEO da Bolt Threads, Dan Widmaier
                </a>
                , que também enfatiza que nenhuma aranha foi lesada nos
                experimentos. A empresa estudou a relação entre o DNA dos
                aracnídeos e as características de suas teias para então usar a
                tecnologia – e não aranhas, para o alívio de aracnofóbicos – na
                reprodução dessas proteínas.
              </p>
            </S.Text>
          </S.Wrapper>
        </S.TextGroup>
      </S.Content>
      <S.Photo2Wrapper>
        <S.CreditPhoto2>Bolt Threads</S.CreditPhoto2>
        <S.Photo2 />
      </S.Photo2Wrapper>
    </S.Container>
  );
};
